import { ActionIcon, Box, Button, Code, Group, MantineBreakpoint, TextInput, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconBell, IconExternalLink, IconMenu, IconMoon, IconSearch, IconSunHigh } from '@tabler/icons-react';
import React, { useState } from 'react';
import CustomDivider from '../CustomDivider';
import DrawerBox from '../DrawerBox';

interface NavPageHeaderProps {
    hiddenFrom?: MantineBreakpoint;
    visibleFrom?: MantineBreakpoint;
    navDrawerContents?: React.ReactNode;
}

function NavPageHeader({ hiddenFrom, visibleFrom, navDrawerContents }: NavPageHeaderProps) {
    const { setColorScheme } = useMantineColorScheme();
    const computedColorScheme = useComputedColorScheme();
    const [open, setOpen] = useState<boolean>(false);

    return (
        <Box style={{
            display: "inline-flex",
            width: "100%",
            borderBottom: "1px solid var(--border-color)",
            padding: "16px",
            justifyContent: "space-between"
        }}>
            <DrawerBox
                isOpen={open}
                onClose={() => { setOpen(false) }}
                withCloseButton
            >
                {navDrawerContents}
            </DrawerBox>
            <Group>
                <ActionIcon
                    className="unify-action-icon-subtle"
                    hiddenFrom="lg"
                    onClick={() => { setOpen(true) }}
                >
                    <IconMenu size={"1.125rem"} />
                </ActionIcon>

                <TextInput
                    variant="unstyled"
                    placeholder="Search"
                    leftSection={<IconSearch size={"1.125rem"} />}
                />
            </Group>

            <Group gap="6px">
                <Button className="unify-btn-subtle" rightSection={<IconExternalLink size={"1.125rem"} />}>
                    Documentation
                </Button>

                <CustomDivider h={22} />

                <ActionIcon className="unify-action-icon-subtle">
                    <IconBell size={"1.125rem"} />
                </ActionIcon>

                {computedColorScheme === "light" ?
                    <ActionIcon className="unify-action-icon-subtle" onClick={() => setColorScheme("dark")}>
                        <IconSunHigh size={"1.125rem"} />
                    </ActionIcon>
                    :
                    <ActionIcon className="unify-action-icon-subtle" radius={"md"} onClick={() => setColorScheme("light")}>
                        <IconMoon size={"1.125rem"} />
                    </ActionIcon>
                }

                <CustomDivider h={22} />

                <Code px={8} py={4} ml={8}>
                    {process.env.REACT_APP_VERSION}
                </Code>
            </Group>
        </Box>
    )
};

export default NavPageHeader;